import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentLayoutComponent } from './layout.component';
import { DocumentItemViewComponent } from '../item-view/item-view.component';
import { FiDocumentLayoutModule } from '../document-layout/document-layout.module';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { DocumentEditService } from '../document-edit.service';
import { DocumentEditItemModule } from '../edit-item/document-edit-item.module';
import { DocumentLanguageSelectorComponent } from '@fi-app/document/layout/document-language-selector/document-language-selector.component';
import { MatButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuModule } from '@angular/material/menu';
import { MatRadioButton } from '@angular/material/radio';

@NgModule({
    imports: [
        CommonModule,
        FiDocumentLayoutModule,
        DocumentEditItemModule,
        MatButton,
        MatMenu,
        MatMenuItem,
        MatRadioButton,
        MatMenuModule,
    ],
    declarations: [DocumentLayoutComponent, DocumentItemViewComponent, DocumentLanguageSelectorComponent],
    exports: [DocumentLayoutComponent, DocumentLanguageSelectorComponent],
    providers: [DetectDevicesService, DocumentEditService],
})
export class DocumentLayoutViewModule {}
